var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManuallyApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F6F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.152 16.785 2.152 2.151 4.733-4.733",
    stroke: "#054254",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.053 10h5.163m-5.163 3.441h3.442m-3.442 3.442h3.442m6.023-4.302V3.976l-2.334 1.037c-.37.165-.555.247-.738.29a2 2 0 0 1-1.454-.213c-.163-.093-.316-.225-.624-.489v0c-.408-.35-.612-.524-.822-.632a2 2 0 0 0-1.823 0c-.21.108-.415.283-.823.632v0c-.307.264-.46.396-.624.49a2 2 0 0 1-1.454.212c-.183-.043-.368-.125-.738-.29L3.75 3.976v10.81c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436h3.075",
    stroke: "#22272F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManuallyApproved);
export default __webpack_public_path__ + "static/media/manually-approved.c53a117c7bd2c904879fe50be48c9d98.svg";
export { ForwardRef as ReactComponent };